import React from 'react';
import { useTranslation } from 'react-i18next';

import Checkbox from 'component/Layout/Form/Checkbox';

import classNames from 'classnames';
import { Feature } from 'config/features';

import { useFeature } from 'hooks/useFeature';

import { Iata } from 'types/Search/airport';

import { ListByCountries } from '../../__config/Airports';
import { countryMap } from '../../__config/mapping';
import { useAirportAutocompleterState } from '../../__context';
import {
    getCurrentCountryOrder,
    getSortedAirportList,
    isFullCountrySelected,
} from '../../__helper/airport';
import { Country as CountryType, Region as RegionType } from '../../types';
import styles from '../Airport.module.scss';

import Airport from './Airport';
import Region from './Region';

interface CountryListProps {
    onCountryClick: (entry: CountryType, isChecked: boolean) => void;
    onRegionClick: (
        country: CountryType,
        isChecked: boolean,
        region: RegionType
    ) => void;
    onClick: (entry: Iata) => void;
}

const Country = ({
    onCountryClick,
    onRegionClick,
    onClick,
}: CountryListProps) => {
    const { t } = useTranslation();
    const { currentValue } = useAirportAutocompleterState();
    const currentList = getCurrentCountryOrder(t('TRANS-locale-country-code'));
    const isS1S4MandatoryActive = useFeature(Feature.S1S4Mandatory);

    return (
        <>
            <div className={styles.Header}>{t('TRANS-all-departure-airports')}</div>
            <div className={styles.ResultList}>
                {currentList?.map((entry) => {
                    const country = ListByCountries[entry];
                    const isChecked = isFullCountrySelected(
                        currentValue,
                        entry
                    );

                    return (
                        <div key={entry} className={styles.Country}>
                            {isS1S4MandatoryActive ? (
                                <div
                                    className={classNames(
                                        styles.ListItem,
                                        styles.NoHover
                                    )}
                                >
                                    <div className={styles.ListItemContent}>
                                        <span>{`${t(
                                            countryMap[entry]
                                        )} `}</span>
                                        <span className={styles.SubLabel}>
                                            {t('TRANS-all-airports')}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <Checkbox
                                    input={{
                                        name: entry,
                                        id: entry,
                                        value: entry,
                                    }}
                                    customClass={{
                                        Label: styles.ListItemContent,
                                        Wrapper: styles.ListItem,
                                    }}
                                    onClick={() =>
                                        onCountryClick(entry, isChecked)
                                    }
                                    onChange={() => {}}
                                    isChecked={isChecked}
                                >
                                    <span>{t(countryMap[entry])}</span>
                                    <span className={styles.SubLabel}>
                                        {t('TRANS-all-airports')}
                                    </span>
                                </Checkbox>
                            )}
                            {country.regionList && (
                                <Region
                                    list={country.regionList}
                                    onRegionClick={onRegionClick}
                                    onAirportClick={onClick}
                                    country={entry}
                                />
                            )}
                            <Airport
                                list={getSortedAirportList(
                                    country.iataCodeList,
                                    t
                                )}
                                onChange={onClick}
                            />
                        </div>
                    );
                })}
            </div>
        </>
    );
};

export default Country;
